// Croatian language content for Ballingo.
// Each skill groups related vocabulary/phrases. Items have:
//   hr: Croatian; sv: Swedish; en: English; note (optional): grammar/usage hint
// Phrases use lower-case unless they're proper nouns or sentence-initial.

export const skills = [
  // ───── A1 ─────────────────────────────────────────────────────────────
  {
    id: 'greetings',
    emoji: '👋',
    color: '#ef476f',
    level: 'A1',
    name: { sv: 'Hälsningar', en: 'Greetings' },
    blurb: {
      sv: 'Säg hej, hej då, tack och varsågod.',
      en: 'Say hello, goodbye, thanks and please.',
    },
    items: [
      { hr: 'bok', sv: 'hej', en: 'hi', note: { sv: 'informellt', en: 'informal' } },
      { hr: 'dobar dan', sv: 'god dag', en: 'good day' },
      { hr: 'dobro jutro', sv: 'god morgon', en: 'good morning' },
      { hr: 'dobra večer', sv: 'god kväll', en: 'good evening' },
      { hr: 'laku noć', sv: 'god natt', en: 'good night' },
      { hr: 'doviđenja', sv: 'hej då', en: 'goodbye' },
      { hr: 'hvala', sv: 'tack', en: 'thank you' },
      { hr: 'molim', sv: 'varsågod', en: 'please / you’re welcome' },
      { hr: 'da', sv: 'ja', en: 'yes' },
      { hr: 'ne', sv: 'nej', en: 'no' },
      { hr: 'oprostite', sv: 'ursäkta', en: 'excuse me' },
      { hr: 'kako ste', sv: 'hur mår du', en: 'how are you', note: { sv: 'formellt', en: 'formal' } },
    ],
  },
  {
    id: 'pronouns-tobe',
    emoji: '🧑',
    color: '#118ab2',
    level: 'A1',
    name: { sv: 'Jag, du, är', en: 'I, you, am' },
    blurb: {
      sv: 'Pronomen och verbet att vara.',
      en: 'Pronouns and the verb to be.',
    },
    items: [
      { hr: 'ja', sv: 'jag', en: 'I' },
      { hr: 'ti', sv: 'du', en: 'you (sg.)' },
      { hr: 'on', sv: 'han', en: 'he' },
      { hr: 'ona', sv: 'hon', en: 'she' },
      { hr: 'mi', sv: 'vi', en: 'we' },
      { hr: 'vi', sv: 'ni', en: 'you (pl.)' },
      { hr: 'oni', sv: 'de', en: 'they' },
      { hr: 'ja sam', sv: 'jag är', en: 'I am' },
      { hr: 'ti si', sv: 'du är', en: 'you are' },
      { hr: 'on je', sv: 'han är', en: 'he is' },
      { hr: 'ona je', sv: 'hon är', en: 'she is' },
      { hr: 'mi smo', sv: 'vi är', en: 'we are' },
      { hr: 'vi ste', sv: 'ni är', en: 'you (pl.) are' },
      { hr: 'oni su', sv: 'de är', en: 'they are' },
    ],
  },
  {
    id: 'people',
    emoji: '🧑‍🤝‍🧑',
    color: '#06d6a0',
    level: 'A1',
    name: { sv: 'Människor', en: 'People' },
    blurb: {
      sv: 'Grundläggande ord för människor.',
      en: 'Basic words for people.',
    },
    items: [
      { hr: 'čovjek', sv: 'människa / man', en: 'person / man' },
      { hr: 'žena', sv: 'kvinna', en: 'woman' },
      { hr: 'muškarac', sv: 'man', en: 'man' },
      { hr: 'dijete', sv: 'barn', en: 'child' },
      { hr: 'dječak', sv: 'pojke', en: 'boy' },
      { hr: 'djevojčica', sv: 'flicka', en: 'girl' },
      { hr: 'prijatelj', sv: 'vän', en: 'friend (m)' },
      { hr: 'prijateljica', sv: 'väninna', en: 'friend (f)' },
      { hr: 'student', sv: 'student', en: 'student (m)' },
      { hr: 'studentica', sv: 'studentska', en: 'student (f)' },
    ],
  },
  {
    id: 'family',
    emoji: '👨‍👩‍👧',
    color: '#ffd166',
    level: 'A1',
    name: { sv: 'Familj', en: 'Family' },
    blurb: {
      sv: 'Familjemedlemmar.',
      en: 'Family members.',
    },
    items: [
      { hr: 'obitelj', sv: 'familj', en: 'family' },
      { hr: 'otac', sv: 'far', en: 'father' },
      { hr: 'tata', sv: 'pappa', en: 'dad' },
      { hr: 'majka', sv: 'mor', en: 'mother' },
      { hr: 'mama', sv: 'mamma', en: 'mom' },
      { hr: 'brat', sv: 'bror', en: 'brother' },
      { hr: 'sestra', sv: 'syster', en: 'sister' },
      { hr: 'sin', sv: 'son', en: 'son' },
      { hr: 'kći', sv: 'dotter', en: 'daughter' },
      { hr: 'baka', sv: 'mormor / farmor', en: 'grandmother' },
      { hr: 'djed', sv: 'morfar / farfar', en: 'grandfather' },
      { hr: 'suprug', sv: 'make', en: 'husband' },
      { hr: 'supruga', sv: 'maka', en: 'wife' },
    ],
  },
  {
    id: 'numbers-1-10',
    emoji: '🔢',
    color: '#8338ec',
    level: 'A1',
    name: { sv: 'Siffror 1–10', en: 'Numbers 1–10' },
    blurb: {
      sv: 'Räkna från ett till tio.',
      en: 'Count from one to ten.',
    },
    items: [
      { hr: 'jedan', sv: 'ett', en: 'one' },
      { hr: 'dva', sv: 'två', en: 'two' },
      { hr: 'tri', sv: 'tre', en: 'three' },
      { hr: 'četiri', sv: 'fyra', en: 'four' },
      { hr: 'pet', sv: 'fem', en: 'five' },
      { hr: 'šest', sv: 'sex', en: 'six' },
      { hr: 'sedam', sv: 'sju', en: 'seven' },
      { hr: 'osam', sv: 'åtta', en: 'eight' },
      { hr: 'devet', sv: 'nio', en: 'nine' },
      { hr: 'deset', sv: 'tio', en: 'ten' },
    ],
  },
  {
    id: 'colors',
    emoji: '🎨',
    color: '#ff006e',
    level: 'A1',
    name: { sv: 'Färger', en: 'Colors' },
    blurb: {
      sv: 'Grundläggande färger.',
      en: 'Basic colors.',
    },
    items: [
      { hr: 'crven', sv: 'röd', en: 'red' },
      { hr: 'plav', sv: 'blå', en: 'blue' },
      { hr: 'žut', sv: 'gul', en: 'yellow' },
      { hr: 'zelen', sv: 'grön', en: 'green' },
      { hr: 'crn', sv: 'svart', en: 'black' },
      { hr: 'bijel', sv: 'vit', en: 'white' },
      { hr: 'siv', sv: 'grå', en: 'gray' },
      { hr: 'smeđ', sv: 'brun', en: 'brown' },
      { hr: 'narančast', sv: 'orange', en: 'orange' },
      { hr: 'ružičast', sv: 'rosa', en: 'pink' },
    ],
  },
  {
    id: 'food',
    emoji: '🍞',
    color: '#fb5607',
    level: 'A1',
    name: { sv: 'Mat', en: 'Food' },
    blurb: {
      sv: 'Vardagsmat och dryck.',
      en: 'Everyday food and drinks.',
    },
    items: [
      { hr: 'hrana', sv: 'mat', en: 'food' },
      { hr: 'voda', sv: 'vatten', en: 'water' },
      { hr: 'kruh', sv: 'bröd', en: 'bread' },
      { hr: 'mlijeko', sv: 'mjölk', en: 'milk' },
      { hr: 'jabuka', sv: 'äpple', en: 'apple' },
      { hr: 'riba', sv: 'fisk', en: 'fish' },
      { hr: 'meso', sv: 'kött', en: 'meat' },
      { hr: 'sir', sv: 'ost', en: 'cheese' },
      { hr: 'jaje', sv: 'ägg', en: 'egg' },
      { hr: 'kava', sv: 'kaffe', en: 'coffee' },
      { hr: 'čaj', sv: 'te', en: 'tea' },
      { hr: 'pivo', sv: 'öl', en: 'beer' },
      { hr: 'vino', sv: 'vin', en: 'wine' },
      { hr: 'šećer', sv: 'socker', en: 'sugar' },
      { hr: 'sol', sv: 'salt', en: 'salt' },
    ],
  },
  {
    id: 'animals',
    emoji: '🐶',
    color: '#3a86ff',
    level: 'A1',
    name: { sv: 'Djur', en: 'Animals' },
    blurb: {
      sv: 'Husdjur och vanliga djur.',
      en: 'Pets and common animals.',
    },
    items: [
      { hr: 'pas', sv: 'hund', en: 'dog' },
      { hr: 'mačka', sv: 'katt', en: 'cat' },
      { hr: 'ptica', sv: 'fågel', en: 'bird' },
      { hr: 'konj', sv: 'häst', en: 'horse' },
      { hr: 'krava', sv: 'ko', en: 'cow' },
      { hr: 'miš', sv: 'mus', en: 'mouse' },
      { hr: 'medvjed', sv: 'björn', en: 'bear' },
      { hr: 'vuk', sv: 'varg', en: 'wolf' },
      { hr: 'lav', sv: 'lejon', en: 'lion' },
      { hr: 'svinja', sv: 'gris', en: 'pig' },
    ],
  },
  {
    id: 'verbs-basic',
    emoji: '⚡',
    color: '#06ba63',
    level: 'A1',
    name: { sv: 'Grundverb', en: 'Basic verbs' },
    blurb: {
      sv: 'Vanliga verb i presens.',
      en: 'Common verbs in present tense.',
    },
    items: [
      { hr: 'imati', sv: 'att ha', en: 'to have' },
      { hr: 'imam', sv: 'jag har', en: 'I have' },
      { hr: 'imaš', sv: 'du har', en: 'you have' },
      { hr: 'ima', sv: 'han/hon har', en: 'he/she has' },
      { hr: 'piti', sv: 'att dricka', en: 'to drink' },
      { hr: 'pijem', sv: 'jag dricker', en: 'I drink' },
      { hr: 'jesti', sv: 'att äta', en: 'to eat' },
      { hr: 'jedem', sv: 'jag äter', en: 'I eat' },
      { hr: 'govoriti', sv: 'att tala', en: 'to speak' },
      { hr: 'govorim', sv: 'jag talar', en: 'I speak' },
      { hr: 'raditi', sv: 'att arbeta', en: 'to work' },
      { hr: 'radim', sv: 'jag arbetar', en: 'I work' },
      { hr: 'ići', sv: 'att gå', en: 'to go' },
      { hr: 'idem', sv: 'jag går', en: 'I go' },
      { hr: 'voljeti', sv: 'att älska / tycka om', en: 'to love / like' },
      { hr: 'volim', sv: 'jag älskar', en: 'I love' },
    ],
  },
  {
    id: 'house',
    emoji: '🏠',
    color: '#5f0f40',
    level: 'A1',
    name: { sv: 'Hem', en: 'Home' },
    blurb: {
      sv: 'Hus, lägenhet och rum.',
      en: 'House, apartment and rooms.',
    },
    items: [
      { hr: 'kuća', sv: 'hus', en: 'house' },
      { hr: 'stan', sv: 'lägenhet', en: 'apartment' },
      { hr: 'soba', sv: 'rum', en: 'room' },
      { hr: 'kuhinja', sv: 'kök', en: 'kitchen' },
      { hr: 'kupaonica', sv: 'badrum', en: 'bathroom' },
      { hr: 'spavaća soba', sv: 'sovrum', en: 'bedroom' },
      { hr: 'vrata', sv: 'dörr', en: 'door' },
      { hr: 'prozor', sv: 'fönster', en: 'window' },
      { hr: 'stol', sv: 'bord', en: 'table' },
      { hr: 'stolica', sv: 'stol', en: 'chair' },
      { hr: 'krevet', sv: 'säng', en: 'bed' },
    ],
  },
  {
    id: 'sentences-1',
    emoji: '💬',
    color: '#9d4edd',
    level: 'A1',
    name: { sv: 'Enkla meningar', en: 'Simple sentences' },
    blurb: {
      sv: 'Kort dialog och vardagsfraser.',
      en: 'Short dialog and everyday phrases.',
    },
    items: [
      { hr: 'kako se zoveš', sv: 'vad heter du', en: 'what is your name' },
      { hr: 'zovem se Ana', sv: 'jag heter Ana', en: 'my name is Ana' },
      { hr: 'drago mi je', sv: 'trevligt att träffas', en: 'nice to meet you' },
      { hr: 'odakle si', sv: 'varifrån är du', en: 'where are you from' },
      { hr: 'iz Švedske sam', sv: 'jag är från Sverige', en: 'I am from Sweden' },
      { hr: 'govorim malo hrvatski', sv: 'jag talar lite kroatiska', en: 'I speak a little Croatian' },
      { hr: 'ne razumijem', sv: 'jag förstår inte', en: 'I don’t understand' },
      { hr: 'govorite li engleski', sv: 'talar du engelska', en: 'do you speak English' },
    ],
  },

  // ───── A2 ─────────────────────────────────────────────────────────────
  {
    id: 'numbers-11-100',
    emoji: '💯',
    color: '#7209b7',
    level: 'A2',
    name: { sv: 'Siffror 11–100', en: 'Numbers 11–100' },
    blurb: {
      sv: 'Större tal och tiotal.',
      en: 'Larger numbers and tens.',
    },
    items: [
      { hr: 'jedanaest', sv: 'elva', en: 'eleven' },
      { hr: 'dvanaest', sv: 'tolv', en: 'twelve' },
      { hr: 'trinaest', sv: 'tretton', en: 'thirteen' },
      { hr: 'četrnaest', sv: 'fjorton', en: 'fourteen' },
      { hr: 'petnaest', sv: 'femton', en: 'fifteen' },
      { hr: 'dvadeset', sv: 'tjugo', en: 'twenty' },
      { hr: 'trideset', sv: 'trettio', en: 'thirty' },
      { hr: 'četrdeset', sv: 'fyrtio', en: 'forty' },
      { hr: 'pedeset', sv: 'femtio', en: 'fifty' },
      { hr: 'sto', sv: 'hundra', en: 'one hundred' },
    ],
  },
  {
    id: 'time-words',
    emoji: '⏰',
    color: '#ff8500',
    level: 'A2',
    name: { sv: 'Tid', en: 'Time' },
    blurb: {
      sv: 'Idag, igår, alltid.',
      en: 'Today, yesterday, always.',
    },
    items: [
      { hr: 'danas', sv: 'idag', en: 'today' },
      { hr: 'sutra', sv: 'imorgon', en: 'tomorrow' },
      { hr: 'jučer', sv: 'igår', en: 'yesterday' },
      { hr: 'sada', sv: 'nu', en: 'now' },
      { hr: 'kasnije', sv: 'senare', en: 'later' },
      { hr: 'uvijek', sv: 'alltid', en: 'always' },
      { hr: 'nikad', sv: 'aldrig', en: 'never' },
      { hr: 'ponekad', sv: 'ibland', en: 'sometimes' },
      { hr: 'često', sv: 'ofta', en: 'often' },
      { hr: 'rano', sv: 'tidigt', en: 'early' },
      { hr: 'kasno', sv: 'sent', en: 'late' },
    ],
  },
  {
    id: 'days',
    emoji: '📅',
    color: '#0077b6',
    level: 'A2',
    name: { sv: 'Veckodagar', en: 'Days of the week' },
    blurb: {
      sv: 'Måndag till söndag.',
      en: 'Monday to Sunday.',
    },
    items: [
      { hr: 'ponedjeljak', sv: 'måndag', en: 'Monday' },
      { hr: 'utorak', sv: 'tisdag', en: 'Tuesday' },
      { hr: 'srijeda', sv: 'onsdag', en: 'Wednesday' },
      { hr: 'četvrtak', sv: 'torsdag', en: 'Thursday' },
      { hr: 'petak', sv: 'fredag', en: 'Friday' },
      { hr: 'subota', sv: 'lördag', en: 'Saturday' },
      { hr: 'nedjelja', sv: 'söndag', en: 'Sunday' },
      { hr: 'tjedan', sv: 'vecka', en: 'week' },
      { hr: 'vikend', sv: 'helg', en: 'weekend' },
    ],
  },
  {
    id: 'months',
    emoji: '🗓️',
    color: '#2ec4b6',
    level: 'A2',
    name: { sv: 'Månader', en: 'Months' },
    blurb: {
      sv: 'Januari till december.',
      en: 'January to December.',
    },
    items: [
      { hr: 'siječanj', sv: 'januari', en: 'January' },
      { hr: 'veljača', sv: 'februari', en: 'February' },
      { hr: 'ožujak', sv: 'mars', en: 'March' },
      { hr: 'travanj', sv: 'april', en: 'April' },
      { hr: 'svibanj', sv: 'maj', en: 'May' },
      { hr: 'lipanj', sv: 'juni', en: 'June' },
      { hr: 'srpanj', sv: 'juli', en: 'July' },
      { hr: 'kolovoz', sv: 'augusti', en: 'August' },
      { hr: 'rujan', sv: 'september', en: 'September' },
      { hr: 'listopad', sv: 'oktober', en: 'October' },
      { hr: 'studeni', sv: 'november', en: 'November' },
      { hr: 'prosinac', sv: 'december', en: 'December' },
    ],
  },
  {
    id: 'weather',
    emoji: '☀️',
    color: '#f4a261',
    level: 'A2',
    name: { sv: 'Väder', en: 'Weather' },
    blurb: {
      sv: 'Sol, regn och årstider.',
      en: 'Sun, rain and seasons.',
    },
    items: [
      { hr: 'sunce', sv: 'sol', en: 'sun' },
      { hr: 'kiša', sv: 'regn', en: 'rain' },
      { hr: 'snijeg', sv: 'snö', en: 'snow' },
      { hr: 'vjetar', sv: 'vind', en: 'wind' },
      { hr: 'oblak', sv: 'moln', en: 'cloud' },
      { hr: 'hladno je', sv: 'det är kallt', en: 'it is cold' },
      { hr: 'toplo je', sv: 'det är varmt', en: 'it is warm' },
      { hr: 'vruće je', sv: 'det är hett', en: 'it is hot' },
      { hr: 'pada kiša', sv: 'det regnar', en: 'it is raining' },
      { hr: 'pada snijeg', sv: 'det snöar', en: 'it is snowing' },
    ],
  },
  {
    id: 'travel',
    emoji: '✈️',
    color: '#e63946',
    level: 'A2',
    name: { sv: 'Resa', en: 'Travel' },
    blurb: {
      sv: 'Transport och biljetter.',
      en: 'Transport and tickets.',
    },
    items: [
      { hr: 'putovanje', sv: 'resa', en: 'trip' },
      { hr: 'aerodrom', sv: 'flygplats', en: 'airport' },
      { hr: 'autobus', sv: 'buss', en: 'bus' },
      { hr: 'vlak', sv: 'tåg', en: 'train' },
      { hr: 'auto', sv: 'bil', en: 'car' },
      { hr: 'karta', sv: 'biljett', en: 'ticket' },
      { hr: 'putovnica', sv: 'pass', en: 'passport' },
      { hr: 'hotel', sv: 'hotell', en: 'hotel' },
      { hr: 'plaža', sv: 'strand', en: 'beach' },
      { hr: 'more', sv: 'hav', en: 'sea' },
      { hr: 'grad', sv: 'stad', en: 'city' },
      { hr: 'selo', sv: 'by', en: 'village' },
    ],
  },
  {
    id: 'restaurant',
    emoji: '🍽️',
    color: '#d62828',
    level: 'A2',
    name: { sv: 'Restaurang', en: 'Restaurant' },
    blurb: {
      sv: 'Beställ mat och be om notan.',
      en: 'Order food and ask for the bill.',
    },
    items: [
      { hr: 'restoran', sv: 'restaurang', en: 'restaurant' },
      { hr: 'jelovnik', sv: 'meny', en: 'menu' },
      { hr: 'račun', sv: 'nota', en: 'bill' },
      { hr: 'konobar', sv: 'servitör', en: 'waiter' },
      { hr: 'juha', sv: 'soppa', en: 'soup' },
      { hr: 'salata', sv: 'sallad', en: 'salad' },
      { hr: 'desert', sv: 'efterrätt', en: 'dessert' },
      { hr: 'molim vas jelovnik', sv: 'kan jag få menyn', en: 'the menu, please' },
      { hr: 'molim vas račun', sv: 'kan jag få notan', en: 'the bill, please' },
      { hr: 'koliko košta', sv: 'hur mycket kostar det', en: 'how much does it cost' },
      { hr: 'ukusno je', sv: 'det är gott', en: 'it is tasty' },
    ],
  },
  {
    id: 'accusative',
    emoji: '🎯',
    color: '#264653',
    level: 'A2',
    name: { sv: 'Akkusativ', en: 'Accusative case' },
    blurb: {
      sv: 'Direkt objekt: -a → -u (fem.), djurliga maskulina får ändelse.',
      en: 'Direct object: -a → -u (fem.), animate masculines get an ending.',
    },
    items: [
      { hr: 'volim kavu', sv: 'jag älskar kaffe', en: 'I love coffee', note: { sv: 'kava → kavu', en: 'kava → kavu' } },
      { hr: 'pijem vodu', sv: 'jag dricker vatten', en: 'I drink water', note: { sv: 'voda → vodu', en: 'voda → vodu' } },
      { hr: 'jedem jabuku', sv: 'jag äter äpplet', en: 'I eat an apple', note: { sv: 'jabuka → jabuku', en: 'jabuka → jabuku' } },
      { hr: 'vidim psa', sv: 'jag ser hunden', en: 'I see the dog', note: { sv: 'pas → psa (djurlig)', en: 'pas → psa (animate)' } },
      { hr: 'vidim mačku', sv: 'jag ser katten', en: 'I see the cat', note: { sv: 'mačka → mačku', en: 'mačka → mačku' } },
      { hr: 'imam brata', sv: 'jag har en bror', en: 'I have a brother', note: { sv: 'brat → brata', en: 'brat → brata' } },
      { hr: 'imam sestru', sv: 'jag har en syster', en: 'I have a sister', note: { sv: 'sestra → sestru', en: 'sestra → sestru' } },
      { hr: 'čitam knjigu', sv: 'jag läser boken', en: 'I am reading the book', note: { sv: 'knjiga → knjigu', en: 'knjiga → knjigu' } },
    ],
  },
  {
    id: 'past-tense',
    emoji: '⏪',
    color: '#7b2cbf',
    level: 'A2',
    name: { sv: 'Dåtid', en: 'Past tense' },
    blurb: {
      sv: 'Perfektum med biti + L-particip.',
      en: 'Perfect tense: biti + L-participle.',
    },
    items: [
      { hr: 'bio sam', sv: 'jag var', en: 'I was (m)' },
      { hr: 'bila sam', sv: 'jag var', en: 'I was (f)' },
      { hr: 'imao sam', sv: 'jag hade', en: 'I had (m)' },
      { hr: 'imala sam', sv: 'jag hade', en: 'I had (f)' },
      { hr: 'bio si u Zagrebu', sv: 'du var i Zagreb', en: 'you were in Zagreb (m)' },
      { hr: 'jeli smo', sv: 'vi åt', en: 'we ate' },
      { hr: 'pili smo', sv: 'vi drack', en: 'we drank' },
      { hr: 'radio sam jučer', sv: 'jag arbetade igår', en: 'I worked yesterday (m)' },
      { hr: 'govorila je', sv: 'hon talade', en: 'she was speaking' },
    ],
  },
  {
    id: 'travel-phrases',
    emoji: '🗺️',
    color: '#1b9aaa',
    level: 'A2',
    name: { sv: 'Reseuttryck', en: 'Travel phrases' },
    blurb: {
      sv: 'Fråga om vägen och hjälp.',
      en: 'Ask for directions and help.',
    },
    items: [
      { hr: 'gdje je', sv: 'var är', en: 'where is' },
      { hr: 'gdje je hotel', sv: 'var är hotellet', en: 'where is the hotel' },
      { hr: 'gdje je toalet', sv: 'var är toaletten', en: 'where is the toilet' },
      { hr: 'lijevo', sv: 'vänster', en: 'left' },
      { hr: 'desno', sv: 'höger', en: 'right' },
      { hr: 'ravno', sv: 'rakt fram', en: 'straight ahead' },
      { hr: 'pomozite mi', sv: 'hjälp mig', en: 'help me' },
      { hr: 'izgubio sam se', sv: 'jag har gått vilse', en: 'I am lost (m)' },
      { hr: 'izgubila sam se', sv: 'jag har gått vilse', en: 'I am lost (f)' },
      { hr: 'koliko je sati', sv: 'vad är klockan', en: 'what time is it' },
    ],
  },
];

// Group skills by level for the home screen
export const levels = [
  { id: 'A1', name: { sv: 'Nivå A1 — Nybörjare', en: 'Level A1 — Beginner' } },
  { id: 'A2', name: { sv: 'Nivå A2 — Lätt mellannivå', en: 'Level A2 — Easy intermediate' } },
];

// Lessons are derived: each skill is sliced into chunks of LESSON_SIZE items.
// The final lesson of each skill is a mixed review using all items.
export const LESSON_SIZE = 5;

export function getLessons(skill) {
  const items = skill.items;
  const chunks = [];
  for (let i = 0; i < items.length; i += LESSON_SIZE) {
    chunks.push(items.slice(i, i + LESSON_SIZE));
  }
  const lessons = chunks.map((chunk, idx) => ({
    id: `${skill.id}-l${idx + 1}`,
    index: idx,
    items: chunk,
    isReview: false,
  }));
  if (items.length > LESSON_SIZE) {
    lessons.push({
      id: `${skill.id}-review`,
      index: lessons.length,
      items,
      isReview: true,
    });
  }
  return lessons;
}

export function getSkill(skillId) {
  return skills.find((s) => s.id === skillId);
}
